export const italiano = {
    modulo: 'Ordini',
    materiale: {
        titolo: 'Richiesta materiali',
        descrizione: 'Ordina dei consumabili'
    },
    elenco: {
        titolo: 'Elenco ordini',
        descrizione: 'Visualizza gli ordini fatti',
        dataTable: {
            numero: 'Numero',
            data: 'Data',
            numMacchina: 'Num. macchina',
            matricola: 'Matricola',
            modello: 'Modello',
            ubicazione: 'Ubicazione',
            materiali: 'Materiali',
            utente: 'Utente',
            stato: 'Stato',
            motivoRifiuto: 'Motivo rifiuto',
        }
    },
    selezionaMatricola: {        
        selezionaSede: 'Seleziona la sede',
        selezionaMatricola: 'Seleziona la matricola'
    },
    tipoRichiesta: {

    },
    riepilogo: {

    }
}

export const inglese = {
    modulo: 'Ordini',
    materiale: {
        titolo: '',
        descrizione: ''
    },
    elenco: {
        titolo: '',
        descrizione: 'Visualizza gli ordini fatti',
        dataTable: {
            numero: 'Numero',
            data: 'Data',
            numMacchina: 'Num. macchina',
            matricola: 'Matricola',
            modello: 'Modello',
            ubicazione: 'Ubicazione',
            materiali: 'Materiali',
            utente: 'Utente',
            stato: 'Stato',
            motivoRifiuto: 'Motivo rifiuto',
        }
    },
    selezionaMatricola: {
        selezionaSede: 'Seleziona la sede',
        selezionaMatricola: 'Seleziona la matricola'
    },
    tipoRichiesta: {

    },
    riepilogo: {

    }
}